import { useEffect, type RefObject } from 'react'

// Publishes the element's pixel height on document.documentElement as `varName`,
// keeping it up to date via ResizeObserver. Clears the var on cleanup so any
// fallback (e.g. `var(--x, 0px)`) applies when the element isn't mounted.
export const usePublishCssVarHeight = (
  ref: RefObject<HTMLElement>,
  varName: string,
  enabled: boolean,
) => {
  useEffect(() => {
    if (!enabled) return undefined
    const el = ref.current
    if (!el) return undefined

    const update = () => {
      document.documentElement.style.setProperty(varName, `${el.offsetHeight}px`)
    }

    update()
    const observer = new ResizeObserver(update)
    observer.observe(el)

    return () => {
      observer.disconnect()
      document.documentElement.style.removeProperty(varName)
    }
  }, [enabled, ref, varName])
}
